export default __webpack_public_path__ + "static/linkedin1-a1932ea6a351750bd0e1c356ec97aea9.png";